/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance } from 'mobx-state-tree';
const { model, string, array, number, maybe, maybeNull } = types;

export const UpgradeLicensePlan = model('UpgradeLicensePlan', {
  list: array(string),
  price_paid_monthly: string,
  price_paid_yearly: string,
  edu_paid_yearly: string,
  edu_paid_monthly: string,
  name: string,
});

export type IUpgradeLicensePlan = Instance<typeof UpgradeLicensePlan>;

// export const PreviousLicenseInfo = model('PreviousLicenseInfo', {
//   core: string,
//   addon: string,
//   numberOfUsersAddOn: number,
//   numberOfUsersCore: number,
//   dateUsersCoreBought: maybe(string),
//   dateUsersCoreExpire: maybe(string),
//   paymentPeriodUsersCore: maybe(string),
//   dateUsersAddonBought: maybe(string),
//   dateUsersAddonExpire: maybe(string),
//   paymentPeriodUsersAddon: maybe(string),
//   currentDate: maybe(string),
//   timeZone: maybe(string),
// });
export const PreviousLicenseInfo = model('PreviousLicenseInfo', {
  core: string,
  addon: string,
  numberOfUsersAddOn: number,
  numberOfUsersCore: number,
  dateUsersCoreBought: maybeNull(string),
  dateUsersCoreExpire: maybeNull(string),
  paymentPeriodUsersCore: maybeNull(string),
  paymentPriceUsersCore: maybeNull(string),
  paymentPeriodUsersAddon: maybeNull(string),
  dateUsersAddonExpire: maybeNull(string),
  currentDate: maybeNull(string),
  timeZone: maybe(string),
});

export type IPreviousLicenseInfo = Instance<typeof PreviousLicenseInfo>;
